import React from 'react'
import ComplianceTextCheckInline from './ComplianceTextCheckInline'
import { Button } from './ui/button'

/**
 * 개인홈 저장 전 표현 리스크 점검 후 저장/수정 선택.
 */
export default function PersonalLandingSaveReviewModal({
  open,
  onClose,
  getComplianceText,
  onConfirmSave,
  saving,
}) {
  if (!open) return null

  return (
    <div className="fixed inset-0 z-[85]">
      <button
        type="button"
        className="absolute inset-0 bg-black/45"
        onClick={onClose}
        aria-label="저장 검토 닫기"
      />
      <div className="relative flex min-h-full items-center justify-center px-3 py-10 sm:px-4 pointer-events-none">
        <div
          className="pointer-events-auto w-full max-w-lg rounded-2xl border border-slate-200 bg-white shadow-2xl overflow-hidden"
          role="dialog"
          aria-modal="true"
          aria-labelledby="landing-save-review-title"
        >
          <div className="flex items-start justify-between gap-3 border-b border-slate-100 px-4 py-4 sm:px-5">
            <div>
              <h2 id="landing-save-review-title" className="text-base font-bold text-slate-900">
                저장 전 확인
              </h2>
              <p className="mt-1 text-[12px] leading-snug text-slate-500">
                공개 페이지 문구는 이용자 책임입니다. 필요 시 표현 리스크를 점검한 뒤 저장하세요.
              </p>
            </div>
            <button
              type="button"
              className="shrink-0 rounded-lg border border-slate-200 px-3 py-1.5 text-sm hover:bg-slate-50"
              onClick={onClose}
            >
              닫기
            </button>
          </div>

          <div className="max-h-[min(72vh,calc(100vh-6rem))] overflow-y-auto px-4 py-4 sm:px-5 space-y-4">
            <div>
              <div className="mb-2 text-xs font-semibold text-slate-700">표현 리스크 점검</div>
              <ComplianceTextCheckInline getText={getComplianceText} label="점검 실행" />
            </div>
          </div>

          <div className="flex flex-col gap-2 border-t border-slate-100 bg-slate-50/90 px-4 py-4 sm:flex-row sm:flex-wrap sm:justify-end sm:px-5">
            <Button type="button" variant="sgezOutline" className="w-full sm:w-auto" onClick={onClose} disabled={saving}>
              수정으로 돌아가기
            </Button>
            <Button
              type="button"
              className="w-full sm:w-auto bg-brand-navy text-white hover:opacity-95"
              onClick={onConfirmSave}
              disabled={saving}
            >
              {saving ? '저장 중…' : '저장하기'}
            </Button>
          </div>
        </div>
      </div>
    </div>
  )
}
